import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    Button,
    Card,
    CardMedia,
    CardActions,
    CardContent,
    CardHeader,
    Container,
    Divider,
    Grid,
    SpeedDial,
    TextField,
    Typography,
    useMediaQuery,
    IconButton,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Backdrop,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from "@mui/material";

import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";

import { getAuth } from "firebase/auth";
import { db, storage } from "../../firebase";
import { serverTimestamp, setDoc, collection, getDoc, doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import imageCompression from "browser-image-compression";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import { useNavigate } from "react-router-dom";

import { Helmet } from "react-helmet-async";

function CharacterCreate() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [user, setUser] = useState("");
    const [chara, setChara] = useState([]);
    const [maxNumber, setMaxNumber] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                const uid = userLogin.uid;
                setUser(uid);
                await fetchData(uid);
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });
        return () => unsubscribe();
    }, []);

    const fetchData = async (uid) => {
        const userRef = collection(db, "member");
        const userDoc = doc(userRef, uid);
        const userSnapshot = await getDoc(userDoc);

        if (userSnapshot.exists()) {
            let charaList = userSnapshot.data().charas;
            setChara(userSnapshot.data().charas);

            if (charaList !== undefined) {
                const maxCarId = Math.max(...charaList.map((item) => item.id));
                if (maxCarId === -Infinity) {
                    setMaxNumber(0);
                } else {
                    setMaxNumber(maxCarId);
                }
            }
        }

        setLoading(false);
    };

    const numberPattern = "[0-9]*";

    const isSP = useMediaQuery("(max-width: 600px)");
    const charaPic = isSP ? "300px" : "400px";
    const skillWidth = isSP ? "304px" : "336px";
    const skillPwidth = isSP ? "144px" : "105px";

    // data
    const [params, setParams] = useState("");

    const [imageUrl, setImageUrl] = useState("");
    const [imageSrc, setImageSrc] = useState("");
    const [imageOpen, setImageOpen] = useState(false);
    const [croppedImgSrc, setCroppedImgSrc] = useState("");
    const [namae, setNamae] = useState("");
    const [furi, setFuri] = useState("");
    const [gender, setGender] = useState("");
    const [age, setAge] = useState(null);
    const [job, setJob] = useState("");
    const [reference, setReference] = useState("");
    const [dead, setDead] = useState(false);
    const [privacy, setPrivacy] = useState(false);
    const [hp, setHp] = useState(0);
    const [mp, setMp] = useState(0);
    const [san, setSan] = useState(0);
    const [lucky, setLucky] = useState(0);
    const [avoid, setAvoid] = useState(0);
    const [db1, setDb1] = useState(0);
    const [build, setBuild] = useState(0);
    const [move, setMove] = useState(0);
    const [str, setStr] = useState(0);
    const [con, setCon] = useState(0);
    const [pow, setPow] = useState(0);
    const [dex, setDex] = useState(0);
    const [app, setApp] = useState(0);
    const [size, setSize] = useState(0);
    const [int, setInt] = useState(0);
    const [edu, setEdu] = useState(0);
    const [str2, setStr2] = useState(0);
    const [con2, setCon2] = useState(0);
    const [dex2, setDex2] = useState(0);
    const [app2, setApp2] = useState(0);
    const [edu2, setEdu2] = useState(0);
    const [move2, setMove2] = useState(0);
    const [correct, setCorrect] = useState(0);
    const [skillPoint, setSkillPoint] = useState(0);
    const [reSkillPoint, setReSkillPoint] = useState(0);
    const [skill, setSkill] = useState([
        { skill: "信用", initial: 0, point: 0, pSum: 0 },
        { skill: "母国語", initial: edu, point: 0, pSum: 0 },
        { skill: "", initial: 0, point: 0, pSum: 0 },
        { skill: "", initial: 0, point: 0, pSum: 0 },
        { skill: "", initial: 0, point: 0, pSum: 0 },
        { skill: "", initial: 0, point: 0, pSum: 0 },
        { skill: "", initial: 0, point: 0, pSum: 0 },
        { skill: "", initial: 0, point: 0, pSum: 0 },
        { skill: "", initial: 0, point: 0, pSum: 0 },
        { skill: "", initial: 0, point: 0, pSum: 0 },
    ]);
    const [property, setProperty] = useState("");
    const [memo, setMemo] = useState("");

    const [cropper, setCropper] = useState(null);
    const inputRef = useRef(null);
    const handleImgOpen = () => {
        inputRef.current.value = "";
        inputRef.current.click();
    };

    const handleImageClick = async (e) => {
        const fileSrc = e.target.files[0];
        const fileUrl = e.target.files;

        if (fileUrl) {
            const supportedImageTypes = ["image/jpeg", "image/jpg", "image/png"];
            if (!supportedImageTypes.includes(fileSrc.type)) {
                console.log("Error: サポートされていない拡張子です");
                return;
            }

            try {
                const options = {
                    maxSizeMB: 2,
                    maxWidthOrHeight: 1280,
                    useWebWorker: true,
                    fileType: fileSrc.type,
                    quality: 0.85,
                };

                const compressedFile = await imageCompression(fileSrc, options);
                const reader = new FileReader();
                reader.readAsDataURL(compressedFile);
                reader.onloadend = () => {
                    setImageSrc(reader.result);
                };
            } catch (error) {
                console.log("Error: ", error);
            }
            setImageOpen(true);
        }
    };

    const onCropperInit = (instance) => {
        setCropper(instance);
    };

    const handleCrop = () => {
        if (cropper) {
            const canvas = cropper.getCroppedCanvas();
            const dataUrl = canvas.toDataURL();
            setImageUrl(dataUrl);
            setCroppedImgSrc(canvas);
        }
        handleCancel();
    };

    const handleCancel = () => {
        setImageOpen(false);
        setImageSrc("");
    };

    const handleDeleteImage = () => {
        setImageUrl("");
        setImageSrc("");
        setCroppedImgSrc("");
    };

    const handleNamaeChange = (event) => {
        setNamae(event.target.value);
    };

    const handleFuriChange = (event) => {
        setFuri(event.target.value);
    };

    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };

    const handleAgeChange = (event) => {
        setAge(event.target.value);

        if (event.target.value >= 40 && event.target.value <= 49) {
            setCorrect(5);
            setApp2(-5);
            setMove2(-1);
        } else if (event.target.value >= 50 && event.target.value <= 59) {
            setCorrect(10);
            setApp2(-10);
            setMove2(-2);
        } else if (event.target.value >= 60 && event.target.value <= 69) {
            setCorrect(20);
            setApp2(-15);
            setMove2(-3);
        } else if (event.target.value >= 70 && event.target.value <= 79) {
            setCorrect(30);
            setApp2(-20);
            setMove2(-4);
        } else if (event.target.value >= 80 && event.target.value <= 89) {
            setCorrect(40);
            setApp2(-25);
            setMove2(-5);
        } else if (event.target.value >= 90) {
            setCorrect(160);
            setApp2(-30);
            setMove2(-6);
        } else {
            setCorrect(0);
            setApp2(0);
            setMove2(0);
        }

        if (event.target.value <= 19) {
            setEdu2(-5);
        } else {
            setEdu2(0);
        }
    };

    const handleJobChange = (event) => {
        setJob(event.target.value);
    };

    const handleReferenceChange = (event) => {
        setReference(event.target.value);
    };

    const handleDeadChange = (event) => {
        setDead(event.target.checked);
    };

    const handlePrivacyChange = (event) => {
        setPrivacy(event.target.checked);
    };

    const handleHpChange = (event) => {
        setHp(event.target.value);
    };

    const handleMpChange = (event) => {
        setMp(event.target.value);
    };

    const handleSanChange = (event) => {
        setSan(event.target.value);
    };

    const handleLuckyChange = (event) => {
        setLucky(event.target.value);
    };

    const handleAvoidChange = (event) => {
        setAvoid(event.target.value);
    };

    const handleDbChange = (event) => {
        setDb1(event.target.value);
    };

    const handleBuildChange = (event) => {
        setBuild(event.target.value);
    };

    const handleMoveChange = (event) => {
        setMove(event.target.value);
    };

    const handleStrChange = (event) => {
        setStr(event.target.value);
    };

    const handleConChange = (event) => {
        setCon(event.target.value);
    };

    const handlePowChange = (event) => {
        setPow(event.target.value);
    };

    const handleDexChange = (event) => {
        setDex(event.target.value);
    };

    const handleAppChange = (event) => {
        setApp(event.target.value);
    };

    const handleSizeChange = (event) => {
        setSize(event.target.value);
    };

    const handleIntChange = (event) => {
        setInt(event.target.value);
    };

    const handleEduChange = (event) => {
        setEdu(event.target.value);
    };

    const handleStr2Change = (event) => {
        if (event.target.value === "") {
            setStr2(0);
        } else {
            setStr2(event.target.value);
        }
    };

    const handleCon2Change = (event) => {
        if (event.target.value === "") {
            setCon2(0);
        } else {
            setCon2(event.target.value);
        }
    };

    const handleDex2Change = (event) => {
        if (event.target.value === "") {
            setDex2(0);
        } else {
            setDex2(event.target.value);
        }
    };

    const skillData = [
        { name: "威圧", val: 15 },
        { name: "言いくるめ", val: 5 },
        { name: "医学", val: 1 },
        { name: "運転", val: 20 },
        { name: "応急手当", val: 30 },
        { name: "オカルト", val: 5 },
        { name: "斧", val: 15 },
        { name: "隠密", val: 20 },
        { name: "火炎放射器", val: 10 },
        { name: "科学", val: 1 },
        { name: "鍵開け", val: 1 },
        { name: "格闘", val: 25 },
        { name: "鑑定", val: 5 },
        { name: "機械修理", val: 10 },
        { name: "聞き耳", val: 20 },
        { name: "クトゥルフ神話", val: 0 },
        { name: "芸術", val: 5 },
        { name: "経理", val: 5 },
        { name: "拳銃", val: 20 },
        { name: "考古学", val: 1 },
        { name: "絞殺ひも", val: 15 },
        { name: "コンピュータ", val: 5 },
        { name: "サバイバル", val: 10 },
        { name: "サブマシンガン", val: 15 },
        { name: "自然", val: 10 },
        { name: "重火器", val: 10 },
        { name: "重機械操作", val: 1 },
        { name: "乗馬", val: 5 },
        { name: "心理学", val: 10 },
        { name: "人類学", val: 1 },
        { name: "水泳", val: 20 },
        { name: "制作", val: 5 },
        { name: "精神分析", val: 1 },
        { name: "説得", val: 10 },
        { name: "操縦", val: 1 },
        { name: "ダイビング", val: 1 },
        { name: "他言語", val: 1 },
        { name: "チェーンソー", val: 10 },
        { name: "跳躍", val: 20 },
        { name: "追跡", val: 10 },
        { name: "手さばき", val: 10 },
        { name: "電気修理", val: 10 },
        { name: "電子工学", val: 1 },
        { name: "伝承", val: 1 },
        { name: "刀剣", val: 20 },
        { name: "登攀", val: 20 },
        { name: "動物使い", val: 5 },
        { name: "読唇術", val: 1 },
        { name: "図書館", val: 20 },
        { name: "ナビゲート", val: 10 },
        { name: "爆破", val: 1 },
        { name: "ヒプノーシス", val: 1 },
        { name: "フレイル", val: 10 },
        { name: "変装", val: 5 },
        { name: "砲", val: 1 },
        { name: "法律", val: 5 },
        { name: "マシンガン", val: 10 },
        { name: "魅惑", val: 15 },
        { name: "むち", val: 5 },
        { name: "目星", val: 25 },
        { name: "槍", val: 20 },
        { name: "弓", val: 15 },
        { name: "ライフル", val: 25 },
        { name: "歴史", val: 5 },
    ];

    const [skillSet, setSkillSet] = useState([
        { val: 15, name: "威圧" },
        { val: 5, name: "言いくるめ" },
        { val: 1, name: "医学" },
        { val: 20, name: "運転" },
        { val: 30, name: "応急手当" },
        { val: 5, name: "オカルト" },
        { val: 15, name: "斧" },
        { val: 20, name: "隠密" },
        { val: 10, name: "火炎放射器" },
        { val: 1, name: "科学" },
        { val: 1, name: "鍵開け" },
        { val: 25, name: "格闘" },
        { val: 5, name: "鑑定" },
        { val: 10, name: "機械修理" },
        { val: 20, name: "聞き耳" },
        {
            val: 0,
            name: "クトゥルフ神話",
        },
        { val: 5, name: "芸術" },
        { val: 5, name: "経理" },
        { val: 20, name: "拳銃" },
        { val: 1, name: "考古学" },
        { val: 15, name: "絞殺ひも" },
        { val: 5, name: "コンピュータ" },
        { val: 10, name: "サバイバル" },
        {
            val: 15,
            name: "サブマシンガン",
        },
        { val: 10, name: "自然" },
        { val: 10, name: "重火器" },
        { val: 1, name: "重機械操作" },
        { val: 5, name: "乗馬" },
        { val: 10, name: "心理学" },
        { val: 1, name: "人類学" },
        { val: 20, name: "水泳" },
        { val: 5, name: "制作" },
        { val: 1, name: "精神分析" },
        { val: 10, name: "説得" },
        { val: 1, name: "操縦" },
        { val: 1, name: "ダイビング" },
        { val: 1, name: "他言語" },
        { val: 10, name: "チェーンソー" },
        { val: 20, name: "跳躍" },
        { val: 10, name: "追跡" },
        { val: 10, name: "手さばき" },
        { val: 10, name: "電気修理" },
        { val: 1, name: "電子工学" },
        { val: 1, name: "伝承" },
        { val: 20, name: "刀剣" },
        { val: 20, name: "登攀" },
        { val: 5, name: "動物使い" },
        { val: 1, name: "読唇術" },
        { val: 20, name: "図書館" },
        { val: 10, name: "ナビゲート" },
        { val: 1, name: "爆破" },
        { val: 1, name: "ヒプノーシス" },
        { val: 10, name: "フレイル" },
        { val: 5, name: "変装" },
        { val: 1, name: "砲" },
        { val: 5, name: "法律" },
        { val: 10, name: "マシンガン" },
        { val: 15, name: "魅惑" },
        { val: 5, name: "むち" },
        { val: 25, name: "目星" },
        { val: 20, name: "槍" },
        { val: 15, name: "弓" },
        { val: 25, name: "ライフル" },
        { val: 5, name: "歴史" },
    ]);

    const handleAddSkill = () => {
        if (skill.length < 30) {
            setSkill([...skill, { name: "", initial: 0, point: 0, pSum: 0 }, { skill: "", initial: 0, point: 0, pSum: 0 }]);
        }
    };

    const handleDelSkill = () => {
        if (skill.length > 4) {
            const updatedSkill = [...skill];
            updatedSkill.pop();
            updatedSkill.pop();
            setSkill(updatedSkill);
        }
    };

    const handleSkillChange = (i, field, value) => {
        const updatedSkill = [...skill];
        const matchedSkillData = skillData.find((item) => item.name === value);

        if (matchedSkillData) {
            updatedSkill[i] = {
                ...updatedSkill[i],
                skill: value,
                initial: parseInt(matchedSkillData.val),
                pSum: parseInt(matchedSkillData.val) + parseInt(updatedSkill[i].point),
            };
        } else {
            updatedSkill[i] = {
                ...updatedSkill[i],
                skill: value,
                initial: 0,
                pSum: updatedSkill[i].point,
            };
        }

        setSkill(updatedSkill);
    };

    const handlePointChange = (i, field, value) => {
        const updatedSkill = [...skill];

        if (/^\d*$/.test(value)) {
            let sum = parseInt(updatedSkill[i]["initial"]) + parseInt(value);
            updatedSkill[i] = {
                ...updatedSkill[i],
                point: value,
                pSum: sum,
            };
        }

        const setData = [...skillSet];
        const skillFit = setData.find((item) => item.name === updatedSkill[i]["skill"]);
        if (skillFit) {
            skillFit.val = updatedSkill[i]["pSum"];
            setSkillSet(setData);
        }

        const total = updatedSkill.reduce((acc, curr) => {
            if (curr.point !== 0) {
                return acc + parseInt(curr.point);
            } else {
                return acc;
            }
        }, 0);
        let result = skillPoint - total;
        setReSkillPoint(result);

        if (!updatedSkill[i][field]) {
            updatedSkill[i] = {
                ...updatedSkill[i],
                point: 0,
                pSum: 0,
            };
            setReSkillPoint(skillPoint);
        }

        setSkill(updatedSkill);
    };

    const handlePropertyChange = (event) => {
        setProperty(event.target.value);
    };

    const handleMemoChange = (event) => {
        setMemo(event.target.value);
    };

    const handleStatesClick = () => {
        let STRResults = 0;
        let CONResults = 0;
        let POWResults = 0;
        let DEXResults = 0;
        let APPResults = 0;
        let SIZEResults = 0;
        let INTResults = 0;
        let EDUResults = 0;
        let LuckyResults = 0;

        for (let i = 0; i < 3; i++) {
            const STRRandom = Math.floor(Math.random() * 6) + 1;
            STRResults += STRRandom;
            const CONRandom = Math.floor(Math.random() * 6) + 1;
            CONResults += CONRandom;
            const POWRandom = Math.floor(Math.random() * 6) + 1;
            POWResults += POWRandom;
            const DEXRandom = Math.floor(Math.random() * 6) + 1;
            DEXResults += DEXRandom;
            const APPRandom = Math.floor(Math.random() * 6) + 1;
            APPResults += APPRandom;
            const LUCKYRandom = Math.floor(Math.random() * 6) + 1;
            LuckyResults += LUCKYRandom;
        }
        for (let j = 0; j < 2; j++) {
            const SIZERandom = Math.floor(Math.random() * 6) + 1;
            SIZEResults += SIZERandom;
            const INTRandom = Math.floor(Math.random() * 6) + 1;
            INTResults += INTRandom;
            const EDURandom = Math.floor(Math.random() * 6) + 1;
            EDUResults += EDURandom;
        }
        STRResults *= 5;
        CONResults *= 5;
        POWResults *= 5;
        DEXResults *= 5;
        APPResults *= 5;
        SIZEResults = (SIZEResults + 6) * 5;
        INTResults = (INTResults + 6) * 5;
        EDUResults = (EDUResults + 6) * 5;
        LuckyResults *= 5;
        setStr(STRResults);
        setCon(CONResults);
        setPow(POWResults);
        setDex(DEXResults);
        setApp(APPResults);
        setSize(SIZEResults);
        setInt(INTResults);
        setEdu(EDUResults);
        setLucky(LuckyResults);
        setHp(Math.floor((CONResults + SIZEResults) / 10));
        setMp(Math.floor(POWResults / 5));
        setSan(POWResults);
        setAvoid(Math.floor(DEXResults / 2));

        if (STRResults + SIZEResults <= 64) {
            setDb1(0);
            setBuild(-2);
        } else if (STRResults + SIZEResults >= 65 && STRResults + SIZEResults <= 84) {
            setDb1(0);
            setBuild(-1);
        } else if (STRResults + SIZEResults >= 85 && STRResults + SIZEResults <= 124) {
            setDb1(0);
            setBuild(0);
        } else if (STRResults + SIZEResults >= 125 && STRResults + SIZEResults <= 164) {
            setDb1("+1D4");
            setBuild(1);
        } else if (STRResults + SIZEResults >= 165) {
            setDb1("+1D6");
            setBuild(2);
        }

        if (STRResults > SIZEResults && DEXResults > SIZEResults) {
            setMove(9);
        } else if (STRResults > SIZEResults && DEXResults < SIZEResults) {
            setMove(7);
        } else {
            setMove(8);
        }

        const job1 = EDUResults * 2 + DEXResults * 2;
        const job2 = EDUResults * 2 + STRResults * 2;
        const job3 = EDUResults * 2 + APPResults * 2;
        const job4 = EDUResults * 2 + POWResults * 2;
        const job5 = EDUResults * 4;
        const jobP = Math.max(job1, job2, job3, job4, job5);
        const hobP = INTResults * 2;
        setSkillPoint(jobP + hobP);
        setReSkillPoint(jobP + hobP);
    };

    const handleUpdateClick = () => {
        setHp(Math.floor((parseInt(con) + parseInt(size)) / 10));
        setMp(Math.floor(parseInt(pow) / 5));
        setSan(parseInt(pow));
        setAvoid(Math.floor(parseInt(dex) / 2));

        if (parseInt(str) + parseInt(size) <= 64) {
            setDb1(0);
            setBuild(-2);
        } else if (parseInt(str) + parseInt(size) >= 65 && parseInt(str) + parseInt(size) <= 84) {
            setDb1(0);
            setBuild(-1);
        } else if (parseInt(str) + parseInt(size) >= 85 && parseInt(str) + parseInt(size) <= 124) {
            setDb1(0);
            setBuild(0);
        } else if (parseInt(str) + parseInt(size) >= 125 && parseInt(str) + parseInt(size) <= 164) {
            setDb1("+1D4");
            setBuild(1);
        } else if (parseInt(str) + parseInt(size) >= 165) {
            setDb1("+1D6");
            setBuild(2);
        }

        const job1 = parseInt(edu) * 2 + parseInt(dex) * 2;
        const job2 = parseInt(edu) * 2 + parseInt(str) * 2;
        const job3 = parseInt(edu) * 2 + parseInt(app) * 2;
        const job4 = parseInt(edu) * 2 + parseInt(pow) * 2;
        const job5 = parseInt(edu) * 4;
        const jobP = Math.max(job1, job2, job3, job4, job5);
        const hobP = parseInt(int) * 2;
        setSkillPoint(jobP + hobP);
        setReSkillPoint(jobP + hobP);
    };

    const handleResetClick = () => {
        setStr(0);
        setCon(0);
        setPow(0);
        setDex(0);
        setApp(0);
        setSize(0);
        setInt(0);
        setEdu(0);
        setHp(0);
        setMp(0);
        setSan(0);
        setLucky(0);
        setAvoid(0);
        setDb1(0);
        setBuild(0);
        setMove(0);
        setApp2(0);
        setEdu2(0);
        setMove2(0);
        setSkillPoint(0);
        setReSkillPoint(0);
    };

    const handleCorrectClick = () => {
        setStr(str + parseInt(str2));
        setCon(parseInt(con) + parseInt(con2));
        setDex(dex + parseInt(dex2));
        setApp(app + app2);
        setEdu(edu + edu2);
        setMove(move + move2);
    };

    const fabs = {
        position: "fixed",
        bottom: "1rem",
        right: "1rem",
    };

    const handleSave = async () => {
        setSaving(true);

        let randomId;
        let charaSnap;
        do {
            randomId = Math.random().toString(36).substring(2, 12);

            const charaRef = doc(db, "character", randomId);
            charaSnap = await getDoc(charaRef);
        } while (charaSnap.exists());
        setParams(randomId);

        if (croppedImgSrc) {
            const strageRef = ref(storage, `character/${randomId}`);

            const blob = await new Promise((resolve) => {
                croppedImgSrc.toBlob((blob) => resolve(blob));
            });

            try {
                await uploadBytes(strageRef, blob);
                const url = await getDownloadURL(strageRef);
                saveToFirestore(url, randomId);
            } catch (error) {
                console.error("Error uploading img: ", error);
            }
        } else {
            saveToFirestoreNotImg(randomId);
        }
    };

    const saveToFirestore = async (url, randomId) => {
        try {
            const memberRef = doc(db, "member", user);
            const charaRef = doc(db, "character", randomId);
            const createDate = new Date();
            chara.push({
                id: maxNumber + 1,
                charaId: randomId,
                createAt: createDate,
            });
            await setDoc(charaRef, {
                id: randomId,
                img: url,
                name: namae,
                furi: furi,
                age: age,
                gender: gender,
                job: job,
                reference: reference,
                hp: hp,
                mp: mp,
                san: san,
                lucky: lucky,
                avoid: avoid,
                db: db1,
                build: build,
                move: move,
                str: str,
                con: con,
                pow: pow,
                dex: dex,
                app: app,
                size: size,
                int: int,
                edu: edu,
                str2: str2,
                con2: con2,
                dex2: dex2,
                app2: app2,
                edu2: edu2,
                move2: move2,
                correct: correct,
                skillPoint: skillPoint,
                reSkillPoint: reSkillPoint,
                skill: skill,
                property: property,
                memo: memo,
                private: privacy,
                dead: dead,
                auther: user,
                updateAt: serverTimestamp(),
                createAt: serverTimestamp(),
                deleted: false,
                deleteAt: null,
            });

            await updateDoc(memberRef, {
                charas: chara,
                updateAt: serverTimestamp(),
            });

            setSaveOpen(true);
        } catch (error) {
            console.error("error: ", error);
        }
    };

    const saveToFirestoreNotImg = async (randomId) => {
        try {
            const memberRef = doc(db, "member", user);
            const charaRef = doc(db, "character", randomId);
            const createDate = new Date();
            chara.push({
                id: maxNumber + 1,
                charaId: randomId,
                createAt: createDate,
            });
            await setDoc(charaRef, {
                id: randomId,
                img: "",
                name: namae,
                furi: furi,
                age: age,
                gender: gender,
                job: job,
                reference: reference,
                hp: hp,
                mp: mp,
                san: san,
                lucky: lucky,
                avoid: avoid,
                db: db1,
                build: build,
                move: move,
                str: str,
                con: con,
                pow: pow,
                dex: dex,
                app: app,
                size: size,
                int: int,
                edu: edu,
                str2: str2,
                con2: con2,
                dex2: dex2,
                app2: app2,
                edu2: edu2,
                move2: move2,
                correct: correct,
                skillPoint: skillPoint,
                reSkillPoint: reSkillPoint,
                skill: skill,
                property: property,
                memo: memo,
                private: privacy,
                dead: dead,
                auther: user,
                updateAt: serverTimestamp(),
                createAt: serverTimestamp(),
                deleted: false,
                deleteAt: null,
            });

            await updateDoc(memberRef, {
                charas: chara,
                updateAt: serverTimestamp(),
            });

            setSaveOpen(true);
        } catch (error) {
            console.error("error: ", error);
        }
    };

    const [saveOpen, setSaveOpen] = useState(false);
    const handleSaved = () => {
        window.scrollTo(0, 0);
        navigate(`/character/${params}`, { replace: true });
    };

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Character Create - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                <Box
                    sx={{ mt: 10, mb: 2 }}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="h6">キャラクター作成</Typography>
                </Box>

                <Card sx={{ mb: 2 }}>
                    <CardHeader title={<Typography variant="h6">基本情報</Typography>} />
                    <CardContent>
                        <Grid container alignItems="top">
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: charaPic,
                                        height: charaPic,
                                        border: "1px solid",
                                        borderColor: "primary.main",
                                        borderRadius: 1,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        position: "relative",
                                        margin: "0 0 10px",
                                        overflow: "hidden",
                                        cursor: "pointer",
                                        m: 1,
                                    }}
                                    onClick={handleImgOpen}
                                >
                                    <input type="file" accept="image/*" onChange={handleImageClick} ref={inputRef} style={{ display: "none" }} />
                                    {imageUrl ? (
                                        <Card>
                                            <CardMedia
                                                component="img"
                                                image={imageUrl}
                                                style={{ position: "relative" }}
                                                sx={{
                                                    objectFit: "contain",
                                                    width: charaPic,
                                                    height: charaPic,
                                                }}
                                            />
                                        </Card>
                                    ) : (
                                        <Box
                                            sx={{
                                                textAlign: "center",
                                                color: "text.secondary",
                                            }}
                                        >
                                            画像をアップロード
                                        </Box>
                                    )}
                                    {imageUrl && (
                                        <IconButton
                                            sx={{
                                                position: "absolute",
                                                top: 10,
                                                right: 10,
                                                color: "white",
                                            }}
                                            style={{
                                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteImage();
                                            }}
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField variant="filled" label="名前" onBlur={handleNamaeChange} fullWidth sx={{ my: 1 }} />
                                <TextField variant="filled" label="フリガナ" onBlur={handleFuriChange} fullWidth sx={{ my: 1 }} />
                                <TextField variant="filled" label="性別" onBlur={handleGenderChange} fullWidth sx={{ my: 1 }} />
                                <TextField
                                    variant="filled"
                                    label="年齢"
                                    onBlur={handleAgeChange}
                                    fullWidth
                                    sx={{ my: 1 }}
                                    inputProps={{
                                        inputMode: "numeric",
                                        pattern: numberPattern,
                                    }}
                                />
                                <TextField variant="filled" label="職業" onBlur={handleJobChange} fullWidth sx={{ my: 1 }} />
                                <TextField
                                    variant="filled"
                                    label="参考にした作品・キャラ等"
                                    onBlur={handleReferenceChange}
                                    fullWidth
                                    sx={{ my: 1 }}
                                />
                                <FormGroup sx={{ my: 1 }}>
                                    <Box sx={{ display: "flex" }}>
                                        <FormControlLabel
                                            checked={dead}
                                            onChange={handleDeadChange}
                                            label="死亡している"
                                            labelPlacement="end"
                                            control={<Checkbox />}
                                            sx={{
                                                width: "fit-content",
                                                "& .MuiFormControlLabel-label": {
                                                    whiteSpace: "nowrap",
                                                },
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ display: "flex" }}>
                                        <FormControlLabel
                                            onChange={handlePrivacyChange}
                                            checked={privacy}
                                            label="非公開にする"
                                            labelPlacement="end"
                                            control={<Checkbox />}
                                            sx={{
                                                width: "fit-content",
                                                my: 1,
                                                "& .MuiFormControlLabel-label": {
                                                    whiteSpace: "nowrap",
                                                },
                                            }}
                                        />
                                    </Box>
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Card sx={{ my: 2 }}>
                    <CardHeader title={<Typography variant="h6">ステータス</Typography>} />
                    <CardContent>
                        <Grid container alignItems="center">
                            <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                                <TextField
                                    variant="filled"
                                    label="HP"
                                    value={hp}
                                    onChange={handleHpChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="MP"
                                    value={mp}
                                    onChange={handleMpChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="SAN"
                                    value={san}
                                    onChange={handleSanChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="幸運"
                                    value={lucky}
                                    onChange={handleLuckyChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        inputMode: "numeric",
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="回避"
                                    value={avoid}
                                    onChange={handleAvoidChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="DB"
                                    value={db1}
                                    onChange={handleDbChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="ビルド"
                                    value={build}
                                    onChange={handleBuildChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="MOVE"
                                    value={move}
                                    onChange={handleMoveChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />

                                <TextField
                                    variant="filled"
                                    label="STR"
                                    value={str}
                                    onChange={handleStrChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="CON"
                                    value={con}
                                    onChange={handleConChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="POW"
                                    value={pow}
                                    onChange={handlePowChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="DEX"
                                    value={dex}
                                    onChange={handleDexChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="APP"
                                    value={app}
                                    onChange={handleAppChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="SIZE"
                                    value={size}
                                    onChange={handleSizeChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="INT"
                                    value={int}
                                    onChange={handleIntChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="EDU"
                                    value={edu}
                                    onChange={handleEduChange}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 2 }} />

                        <Typography variant="body1" sx={{ m: 2 }}>
                            補正
                        </Typography>
                        <Grid container alignItems="center">
                            <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                                <TextField
                                    variant="filled"
                                    label="STR"
                                    onBlur={handleStr2Change}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="CON"
                                    onBlur={handleCon2Change}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="DEX"
                                    onBlur={handleDex2Change}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="APP"
                                    value={app2}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="EDU"
                                    value={edu2}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="filled"
                                    label="MOVE"
                                    value={move2}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <Button color="secondary" size="large" variant="contained" sx={{ m: 1, mt: 3 }} onClick={handleCorrectClick}>
                                    補正を適用
                                </Button>
                                <Button color="info" size="large" variant="contained" sx={{ m: 1, mt: 3 }} onClick={handleUpdateClick}>
                                    数値を更新
                                </Button>
                            </Grid>
                        </Grid>
                        <Typography variant="body2" sx={{ mt: 2, mb: 1, mx: 2 }}>
                            ※1 年齢により変動します
                        </Typography>
                        <Typography variant="body2" sx={{ mx: 2, mb: 1 }}>
                            ※2 STR, CON, DEX の中から合計【 {correct} 】減らしてください
                        </Typography>
                        <Typography variant="body2" sx={{ mx: 2 }}>
                            ※3 入力例： -10
                        </Typography>
                    </CardContent>
                    <CardActions sx={{ m: 1 }} style={{ display: "flex", justifyContent: "right" }}>
                        <Button color="error" size="large" onClick={handleResetClick}>
                            リセット
                        </Button>
                        <Button color="success" size="large" variant="contained" onClick={handleStatesClick}>
                            ステ振り
                        </Button>
                    </CardActions>
                </Card>

                <Card sx={{ my: 2 }}>
                    <CardContent>
                        <Grid container sx={{ mb: 4 }}>
                            <Grid item xs={6} sm={6}>
                                <Typography variant="h6">技能ポイント</Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button variant="contained" color="info" onClick={handleAddSkill} disabled={skill.length === 30}>
                                    スキル追加
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Grid item xs={5.3} sm={5.8} style={{ textAlign: "center" }} sx={{ mx: 1 }}>
                                <TextField
                                    variant="filled"
                                    label="技能ポイント"
                                    value={skillPoint}
                                    fullWidth
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={5.3} sm={5.8} style={{ textAlign: "center" }} sx={{ mx: 1 }}>
                                <TextField
                                    variant="filled"
                                    label="残りポイント"
                                    value={reSkillPoint}
                                    fullWidth
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: 5 }} style={{ display: "flex", justifyContent: "center" }}>
                            {skill.map((sk, i) => (
                                <Grid item key={i} xs={12} sm={6} sx={{ my: 1 }} style={{ textAlign: "center" }}>
                                    <TextField
                                        variant="filled"
                                        label="技能"
                                        defaultValue={sk.skill}
                                        onBlur={(e) => handleSkillChange(i, "name", e.target.value)}
                                        sx={{ mx: 1, width: skillWidth }}
                                    />

                                    <TextField
                                        inputMode="numeric"
                                        variant="filled"
                                        label="割り振り"
                                        value={sk.point}
                                        onChange={(e) => handlePointChange(i, "point", e.target.value)}
                                        sx={{ mx: 1, width: skillPwidth }}
                                        inputProps={{
                                            style: { textAlign: "right" },
                                        }}
                                    />
                                    <TextField
                                        variant="filled"
                                        label="合計"
                                        value={sk.pSum}
                                        sx={{ mx: 1, width: skillPwidth }}
                                        inputProps={{
                                            style: { textAlign: "right" },
                                            readOnly: true,
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        <Box sx={{ my: 2 }} style={{ display: "flex", justifyContent: "center" }}>
                            <Button variant="contained" color="error" onClick={handleDelSkill} disabled={skill.length === 4}>
                                行を削除
                            </Button>
                        </Box>
                    </CardContent>
                </Card>

                <Card sx={{ my: 2 }}>
                    <CardHeader title={<Typography variant="h6">その他</Typography>} />
                    <CardContent>
                        <Grid
                            container
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Grid item xs={12} sm={5.8} sx={{ m: 1 }}>
                                <TextField variant="filled" label="持ち物" multiline rows={10} fullWidth onBlur={handlePropertyChange} />
                            </Grid>
                            <Grid item xs={12} sm={5.8} sx={{ m: 1 }}>
                                <TextField variant="filled" label="メモ" onBlur={handleMemoChange} multiline rows={10} fullWidth />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Box style={fabs}>
                    <SpeedDial ariaLabel="Action SpeedDial" icon={<SaveIcon />} onClick={handleSave} />
                </Box>
            </Container>

            <Dialog open={imageOpen} onClose={handleCancel}>
                <DialogTitle
                    sx={{
                        minWidth: 330,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    トリミング
                </DialogTitle>
                <DialogContent>
                    {imageSrc && (
                        <Box>
                            <Cropper
                                src={imageSrc}
                                style={{ height: 350, width: "100%" }}
                                initialAspectRatio={500 / 500}
                                cropBoxMovable={false}
                                cropBoxResizable={false}
                                guides={false}
                                toggleDragModeOnDblclick={false}
                                dragMode="move"
                                onInitialized={(instance) => onCropperInit(instance)}
                                wheelZoomRatio={0.02}
                            />
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleCancel}>
                        キャンセル
                    </Button>
                    <Button onClick={handleCrop} variant="contained">
                        切り抜く
                    </Button>
                </DialogActions>
            </Dialog>

            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={saving}
            >
                <CircularProgress size="3rem" />
            </Backdrop>

            {/* 保存完了のダイアログ */}
            <Dialog open={saveOpen}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    作成しました
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleSaved}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default CharacterCreate;
